module.exports = __webpack_public_path__ + "static/media/fly0278.7f8cbb6e.webp";